import { Button, Grid, Typography } from '@material-ui/core';
import React, { VFC } from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from 'containers/ChatAgent/messages';

import { useSetupInstructionsStyles } from './styles';

interface SetupInstructionsProps {
  onStartChatbotProgressor: () => void;
}

export const SetupInstructions: VFC<SetupInstructionsProps> = ({
  onStartChatbotProgressor,
}) => {
  const classes = useSetupInstructionsStyles();

  return (
    <Grid className={classes.container}>
      <Grid className={classes.header}>
        <Typography variant="h2">
          <FormattedMessage {...messages.header} />
        </Typography>
      </Grid>
      <Grid className={classes.content}>
        <Grid className={classes.section}>
          <Grid>
            <Typography variant="h2">
              <FormattedMessage {...messages.setupFirstWidget} />
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="body2">
              <FormattedMessage {...messages.setupDescription} />
            </Typography>
          </Grid>
          <Grid className={classes.list}>
            <Grid>
              1. <b>Personalize AI Agent</b> by customizing its name and apply
              brand to match its appearance.
            </Grid>
            <Grid>
              2. <b>Set AI Agent Functionalities</b> to define its interactions
              with candidates and determine the platforms it will appear on.
            </Grid>
            <Grid>
              3. <b>Train AI Agent</b> by uploading a knowledge base to ensure
              it delivers accurate and relevant responses to candidates.
            </Grid>
          </Grid>
        </Grid>
        <Grid className={classes.footer}>
          <Button
            variant="contained"
            size="small"
            color="primary"
            onClick={onStartChatbotProgressor}
          >
            <FormattedMessage {...messages.setupAiAgent} />
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
